import React from 'react';
import { connect } from "react-redux";
import { withRouter } from '../../../shared/hoc/withRouter';
import AIChatBotIcon from "../../../../_metronic/layout/assets/bi_bot_light.png";
import { RiArrowUpCircleFill, RiDeleteBin2Fill } from 'react-icons/ri';
import axios from 'axios';
import PortletSpinner from '../../../partials/layout/PortletSpinner';
import ReactMarkdown from "react-markdown";

const styles = {
    suggestionLabel: {
        border: '1px solid #ddd',
        backgroundColor: '#fff',
        borderRadius: '999px',
        padding: '5px 10px',
        fontSize: '12px',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
    },

    activeSuggestionLabel: {
    backgroundColor: '#1a365d',
    color: '#fff',
    borderColor: '#1a365d',
},

    tooltip: {
    position: 'absolute',
    bottom: '35px',
    backgroundColor: '#333',
    color: '#fff',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    zIndex: 2000,
    left: '300px'
},

disabledSuggestionLabel: {
    opacity: 0.5,
    cursor: "not-allowed",
    backgroundColor: "#f5f5f5",
    color: "#999",
    borderColor: "#ddd",
}
};

class NewAIChatBot extends React.Component {

assistedDraftingEnabledForInstance = process.env.REACT_APP_ASSISTED_DRAFTING_ENABLED === "true";
globalSearchEnabled = process.env.REACT_APP_GLOBAL_SEARCH_ENABLED === "true";
    
    constructor(props) {
        super(props);
        this.conversationEndRef = React.createRef(); // Need to support the autoscroll of the conversation container
        this.suggestionsRef = React.createRef();
        this.state = {
    activeMode: "howDoI",

    chats: {
        howDoI: {
            sessionID: null,
            conversation: [],
            isStartingSession: false,
        },
        draftNotice: {
            sessionID: null,
            conversation: [],
            isStartingSession: false,
        },
    },

    question: "",
    loading: false,
};
    }
    componentDidMount() {
    if (this.props.isOpen && this.props.isNewChatTabActive) {
        this.startSession();
    }
    //this.handleResumedSession();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.newChatRequestId !== this.props.newChatRequestId) {
            this.startNewChat();
        }

        const prevConversation = prevState.chats[prevState.activeMode].conversation;

        const currentConversation = this.state.chats[this.state.activeMode].conversation;

        if (prevConversation !== currentConversation) {
            this.scrollToBottom();
        }
    }

    scrollToBottom = () => {
        if (this.conversationEndRef.current) {
            this.conversationEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    clearConversation = () => {
        this.setState(prev => ({
            chats: {
                ...prev.chats,
                [prev.activeMode]: {
                    ...prev.chats[prev.activeMode],
                    conversation: []
                }
            },
            question: ""
        }));
    };

    startNewChat = async () => {
        const mode = this.state.activeMode;

        this.setState(prev => ({
            chats: {
                ...prev.chats,
                [mode]: {
                    sessionID: null,
                    conversation: [],
                    isStartingSession: false,
                }
            },
            question: "",
            loading: false,
        }), () => this.startSession(mode));
    };

    // Comment out for beta phase 1
    // handleResumedSession = () => {
    //     const { resumedSession } = this.props;
    //     if (resumedSession) {
    //         const { sessionId, userQuestion, assistantResponse } = resumedSession;
            
    //         this.setState({
    //             sessionID: sessionId,
    //             conversation: [{ question: userQuestion, response: assistantResponse }],
    //             question: '',
    //         });
    //     }
    // };

    startSession = async (chatMode = this.state.activeMode) => {
        const chat = this.state.chats[chatMode];

        if (chat.sessionID || chat.isStartingSession) {
            return;
        }

        try {
            this.setState(prev => ({
            chats: {
                ...prev.chats,
                [chatMode]: {
                    ...prev.chats[chatMode],
                    isStartingSession: true,
                }
            }
        }));

            const token = this.props.authToken.chatbotToken;
            const userEmail = this.props.userProfile?.email;

            if (!userEmail) {
                console.error("Cannot start chatbot session: user email is missing.");
                return;
            }

            const { data: responseObj } = await axios.post(
                'https://zendeskhelpbotuatapi.builtintelligence.com/api/Session/StartSession',
                { UserEmail: userEmail },
                {
                    headers: {
                        'X-USER-TOKEN': token,
                        'Content-Type': 'application/json',
                        'Accept': '*/*',
                    },
                }
            );

            this.setState(prev => ({
            chats: {
                ...prev.chats,
                [chatMode]: {
                    ...prev.chats[chatMode],
                    sessionID: responseObj.id || responseObj.Id,
                    isStartingSession: false,
                }
            }
        }));

        } catch (error) {
            console.log(error);
            this.setState(prev => ({
            chats: {
                ...prev.chats,
                [chatMode]: {
                    ...prev.chats[chatMode],
                    isStartingSession: false,
                }
            }
        }));
        }
    };

    // Had to use Fetch as i couldnt get this to work with axios
    askQuestion = async () => {
        try {
            const { question, activeMode } = this.state;
            const currentChat = this.state.chats[activeMode];

                    if (!question.trim()) {
                        return;
                    }

            if (!currentChat.sessionID) {
                await this.startSession(activeMode);

                const refreshedChat = this.state.chats[activeMode];

                if (!refreshedChat.sessionID) {
                    console.error(`${activeMode} session has not been created yet.`);
                    return;
                }
            }

            if (!question.trim()) return;

            this.setState(prev => ({
                chats: {
                    ...prev.chats,
                    [activeMode]: {
                        ...prev.chats[activeMode],
                        conversation: [
                            ...prev.chats[activeMode].conversation,
                            {
                                question: `<strong>You:</strong><br/>${question}`,
                                response: "",
                            },
                        ],
                    },
                },
                question: "",
                loading: true,
            }));

            const token = this.props.authToken.chatbotToken;

            const getApiUrl = () => {
                if (activeMode === 'draftNotice') {
                    return "https://zendeskhelpbotuatapi.builtintelligence.com/api/Session/StreamResponseWithSessionAssistant";
                }

                return "https://zendeskhelpbotuatapi.builtintelligence.com/api/Chat/StreamDirectChatResponse";
            };

            const refreshedChat = this.state.chats[activeMode];

            //
            const response = await fetch(
                getApiUrl(),
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-USER-TOKEN": token,
                    },
                    body: JSON.stringify(
                        activeMode === 'draftNotice'
                            ? {
                                SessionId: refreshedChat.sessionID,
                                Question: question
                            }
                            : {
                                SessionId: refreshedChat.sessionID,
                                Query: question
                            }
                    ),
                }
            );

            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");

            let accumulated = "";

            while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            const chunk = decoder.decode(value, { stream: true });
            accumulated += chunk;

            // Update the last conversation entry progressively
            this.setState(prevState => {
                const updatedConversation = [
                    ...prevState.chats[activeMode].conversation
                ];

                updatedConversation[updatedConversation.length - 1].response = accumulated;

                return {
                    chats: {
                        ...prevState.chats,
                        [activeMode]: {
                            ...prevState.chats[activeMode],
                            conversation: updatedConversation,
                        },
                    },
                };
            });
            }

            this.setState({ loading: false });
        } catch (error) {
            console.error(error);
            this.setState({ loading: false });
        }
    };

    handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) { // Enter without Shift submits
            e.preventDefault(); // Prevent newline
            this.askQuestion();
        }
    };

    // Comment out for beta phase 1
    // setResumedSession = (userQuestion, assistantResponse, sessionId) => {
    //     this.setState({
    //         sessionID: sessionId,
    //         conversation: [{ question: userQuestion, response: assistantResponse }],
    //         question: '', // Ensure textarea is clear
    //     });
    // };


        setChatMode = async (chatMode) => {
            this.setState({ activeMode: chatMode });

            const chat = this.state.chats[chatMode];

            if (!chat.sessionID) {
                await this.startSession(chatMode);
            }
        };

    render() {
        const { loading, question, activeMode } = this.state;
        const conversation = this.state.chats[activeMode].conversation;
        const globalSearchEnabled = process.env.REACT_APP_GLOBAL_SEARCH_ENABLED === "true";
        const canUseAssistedDrafting = this.assistedDraftingEnabledForInstance && this.props.userProfile?.assistedDraftingEnabled;
    
        return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginLeft: '10px',
                    marginRight: '10px',
                    alignItems: 'center',
                    width: 'calc(100% - 20px)',
                    height: '100%',
                    position: 'relative',
                    boxSizing: 'border-box',
                }}>

                {/* Icon */}
                <div
                    style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 'calc(100% - 40px)',
                    position: 'relative',
                }}
                >
                    {/* Icon */}
                    <span
                        style={{
                        display: 'flex',
                        alignItems: 'center',
                        }}
                    >
                        <img
                        src={AIChatBotIcon}
                        id="kt_quick_panel_toggler_btn_4"
                        alt="AI Chatbot"
                        className="icon-image"
                        style={{ height: '50px', marginRight: '10px' }}
                        />
                    </span>

                    {/* Label */}
                    <h1 style={{ marginLeft: '10px', fontWeight: 'bold', color: '#000' }}>
                        BI SupportBot
                    </h1>
                </div>


                {/* Conversation History */}
                <div
                
                    style={{
                        width: 'calc(100% - 40px)',
                        marginTop: '20px',
                        flex: '1 1 auto',
                        maxHeight: '400px',
                        minHeight: '400px',
                        overflowY: 'auto',
                        padding: '10px',
                        marginBottom: '15px',
                        boxSizing: 'border-box',
                    }}
                    ref={(el) => { this.conversationContainer = el; }}
                >
                    {conversation.map((item, index) => (
                        <div key={index} style={{ marginBottom: '20px' }}>
                            {/* User's Question (Right-Aligned) */}
                            {item.question && (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        marginBottom: '10px',
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'inline-block',
                                            width: 'fit-content',
                                            maxWidth: '75%',
                                            padding: '10px',
                                            backgroundColor: '#007bff',
                                            color: '#fff',
                                            borderRadius: '10px',
                                            fontSize: '16px',
                                            lineHeight: '1.5',
                                            textAlign: 'left',
                                            whiteSpace: 'pre-wrap',
                                            wordBreak: 'break-word',
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: item.question
                                                .replace(/\n+/g, ' ')
                                                .replace(/^(.*?)(?=\d+\.\s*\*\*)/, '$1<br /><br />')
                                                .replace(/(\d+\.\s*\*\*.*?)(?=\d+\.\s*\*\*|$)/g, '$1<br /><br />')
                                                .trim(),
                                        }}
                                    />
                                </div>
                            )}

                            {/* AI Response or Spinner (Left-Aligned) */}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                }}
                            >
                                {item.response && (
                                    <div
                                        style={{
                                            display: "inline-block",
                                            width: "fit-content",
                                            maxWidth: "75%",
                                            padding: "10px",
                                            backgroundColor: "#f9f9f9",
                                            border: "1px solid #e0e0e0",
                                            borderRadius: "10px",
                                            fontSize: "16px",
                                            lineHeight: "1.6",
                                            color: "#333",
                                            textAlign: "left",
                                            wordBreak: "break-word",
                                        }}
                                    >
                                        <ReactMarkdown>
                                            {item.response}
                                        </ReactMarkdown>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                    <div ref={this.conversationEndRef} /> {/* Dummy div for auto-scroll */}
                </div>

                {/* Footer Warning */}
                <div
                    style={{
                        width: '100%',
                        padding: '6px 10px',
                        textAlign: 'center',
                        fontSize: '12px',
                        lineHeight: '1.3',
                        fontWeight: '350',
                        backgroundColor: '#fff',
                        boxSizing: 'border-box',
                        marginBottom: '5px'
                        
                    }}
                >
                    This bot is read-only and does not access project, contract or client data. BI SupportBot can make mistakes. Please check important information.
                </div>

                <div
                    className="ai-parent"
                    style={{
                        width: '100%',
                        boxSizing: 'border-box'
                    }}
                >
                    {/* Textarea and submit */}
                    
                    <div
                        className="ai-textarea-container"
                        style={{
                            width: '100%',
                            position: 'sticky',
                            boxSizing: 'border-box',
                        }}
                    >
                        <textarea
                            placeholder="You can select a prompt below to get started..."
                            value={question}
                            onChange={(e) => this.setState({ question: e.target.value })}
                            onKeyDown={this.handleKeyPress}
                            style={{
                            width: '100%',
                            padding: '10px 10px 10px 10px',
                            borderRadius: '5px',
                            fontSize: '16px',
                            boxSizing: 'border-box',
                            resize: 'vertical',
                            minHeight: '80px',
                            maxHeight: '200px',
                            lineHeight: '1.5',
                            fontFamily: 'inherit',
                            overflowY: 'auto',
                            marginTop: '0px'
                            }}
                            rows={1}
                            onInput={(e) => {
                                e.target.style.height = 'auto';
                                e.target.style.height = `${Math.min(e.target.scrollHeight, 200)}px`;
                            }}
                        />
                        <RiArrowUpCircleFill
                            style={{
                            position: 'absolute',
                            right: '15px',
                            bottom: '10px',
                            fontSize: '30px',
                            cursor: 'pointer',
                            transition: 'color 0.2s',
                            }}
                            onClick={this.askQuestion}
                        />
                        <RiDeleteBin2Fill
                            style={{
                            position: 'absolute',
                            right: '45px',
                            bottom: '10px',
                            fontSize: '30px',
                            cursor: 'pointer',
                            color: '#dc3545',
                            transition: 'color 0.2s',
                            }}
                            onClick={this.clearConversation}
                        />
                    </div>
                    <div

                    ref={this.suggestionsRef}
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '10px',
                            marginTop: '8px',
                            flexWrap: 'wrap',
                            position: 'relative',
                        }}
                    >
                        <button
                        type="button"
                        onClick={() => this.setChatMode('howDoI')}
                        style={{
                            ...styles.suggestionLabel,
                            ...(this.state.activeMode === 'howDoI' ? styles.activeSuggestionLabel : {})
                        }}
                        >
                            How Do I?
                        </button>

                        <button
                            type="button"
                            disabled={!canUseAssistedDrafting}
                            onClick={() => {
                                if (canUseAssistedDrafting) {
                                    this.setChatMode("draftNotice");
                                }
                            }}
                            style={{
                                ...styles.suggestionLabel,
                                ...(this.state.activeMode === "draftNotice"
                                    ? styles.activeSuggestionLabel
                                    : {}),
                                ...(!canUseAssistedDrafting
                                    ? styles.disabledSuggestionLabel
                                    : {}),
                            }}
                            //title={!canUseAssistedDrafting ? "Coming Soon" : ""}
                        >
                            Draft Notice
                        </button>



                        {globalSearchEnabled && (
                        <button
                            type="button"
                            onClick={() => this.props.navigate("/search")}
                            style={styles.suggestionLabel}
                        >
                            Search
                        </button>
                        )}

                        <button
                            type="button"
                            disabled
                            style={{
                                ...styles.suggestionLabel,
                                ...styles.disabledSuggestionLabel,
                            }}
                            //title="Coming Soon"
                        >
                            Summarise
                        </button>
                            
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    authToken: store.auth.authToken,
    userProfile: store.auth.userProfile
});

export default withRouter(connect(mapStateToProps)(NewAIChatBot));